import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  HireDotNetExtensive,
  HireDotNetCertified,
  HireDotNetCustomized,
  HireDotNetSeamless,
  HireDotNetTimely,
  HireDotNetSupport,
} from "../../../app-constants";

function Whychoosespeeech() {
  return (
    <section
      className="voice_services why_choose_speech p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={7}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Comprehensive <span>Game Development</span> Services
            </h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Full-Cycle Development</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Our flexible development process, adapted for your
                      project, will provide support for every stage, starting
                      with the idea and ending with the game's support after its
                      release.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>3D Art Creation</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Our team employs the best modeling tools to create
                      graphics-rich and design assets that even the most
                      up-to-date mobile devices can handle.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>AAA-Grade Visuals</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Using state-of-the-art tools, we produce high-quality
                      images for consoles suitable for the mobile platform so
                      that your game can easily compete in the market.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Advanced 3D Animation</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Through rigging and keyframing, our animators produce
                      organic movements across characters and environments that
                      resemble life-like fluidity.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Intuitive Game UI/UX Design</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We design user-friendly interfaces following the current
                      guidelines and standards, improving players’ satisfaction
                      while navigating in the game.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Rigorous QA Testing</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      QA is an important aspect of our development cycle. We
                      provide manual and automated tests to ensure flawless
                      results compliant with modern industry standards
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
